<template>
    <div class="sign-in">
        <div class="error-card" v-if="error">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>{{ error }}</p>
        </div>

        <div
            class="error-card"
            :key="key"
            v-for="(error, key) in passwordResetErrors"
        >
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>{{ error }}</p>
        </div>

        <header>
            <p>Please enter your new password</p>
        </header>

        <form name="password" @submit.prevent="changePassword()">
            <!--Hidden Input used to fix chrome warning:
                Password forms should have (optionally hidden) username fields for accessibility
            -->
            <input type="text" name="email" autocomplete="username email" style="display: none;">

            <label>
                Enter Password

                <input
                    name="password"
                    type="password"
                    required
                    placeholder="Enter Password"
                    autocomplete="new-password"
                    v-model="changePassword.password"
                >
            </label>

            <label>
                Confirm Password

                <input
                    name="confirm-password"
                    type="password"
                    required
                    placeholder="Enter Confirm Password"
                    autocomplete="new-password"
                    v-model="changePassword.confirmPassword"
                >
            </label>

            <a @click="$router.push('/')">
                Back to Sign In
            </a>

            <button :disabled="loading">
                {{ loading ? 'Loading...' : 'Change Password'}}
            </button>
        </form>
    </div>
</template>

<script>
import Form from '@/class/Form'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (!vm.passwordResetId) {
				next('/')
			}
		})
	},

	beforeLeaveEnter (to, from, next) {
		this.clearForm()

		next()
	},

	computed: {
		...mapFields([
			'changePassword',
			'error',
			'loading',

			'passwordResetId',
			'isPasswordResetSuccess',
			'passwordResetErrors'
		])
	},

	methods: {
		/* Login */
		async changePassword () {
			this.error = ''
			this.passwordResetErrors = []

			const { form, validated } = await this.validate()

			if (validated) {
				const formData = new FormData()
				formData.append('id', this.passwordResetId)
				formData.append('password', form.get('password'))
				formData.append('password_confirmation', form.get('confirmPassword'))

				this.$store.dispatch('changePassword', { form: formData, router: this.$router })
			}
		},

		async validate () {
			const form = new Form(this.changePassword)
			const data = {
				form,
				validated: true
			}

			if (!form.isMatch('password', 'confirmPassword')) {
				data.validated = false
				this.error = 'Password does not match.'
			}

			return data
		},

		/* Before Route Leave */
		clearForm () {
			this.passwordResetErrors = []

			this.changePassword = {
				password: '',
		        confirmPassword: ''
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.sign-in {
    height: 100%;
    width: 100%;
    color: #fff;

    .logo {
        margin-bottom: 20px;
    }

    .error-card {
        background-color: $danger;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        @include flex-row(flex-start, center);

        p {
            margin-left: 10px;
            font-style: italic;
        }
    }

    header {
        margin-bottom: 20px;
    }

    form {
        label {
            color: #fff;
            margin-bottom: 20px;
            display: block;
            width: 100%;
            cursor: pointer;

            input {
                display: block;
                width: 100%;
                margin-top: 15px;
                padding: 10px 15px;
                font-weight: 400;

                &::placeholder {
                    font-weight: 400;
                    color: #95989a;
                }
            }
        }

        a {
            color: #fff;
            margin: 10px 0;
            display: inline-block;
            transition: 0.3s;

            &:hover {
                text-decoration: underline;
            }
        }

        button {
            border: 2px solid #fff;
            color: #fff;
            font-size: 18px;
            margin: 10px 0;
            background-color: transparent;
            width: 100%;
            transition: 0.3s;
            padding: 10px 0;

            &:hover {
                background-color: $primary;
                border-color: $primary;
            }
        }
    }

    header {
        h2, p {
            text-align: center;
            margin-bottom: 15px;
        }
    }
}
</style>
